import { FC } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import BottomSheet from '../BottomSheet';
import Button from '../Button';
import { fontStyles, spacing } from '../../styles';
import graph from '../../assets/onboardingImages/graph.svg';

export interface Props {
  isShown: boolean;
  onClose: () => void;
}

const ReturnMethodologyBottomSheet: FC<Props> = ({ isShown, onClose }) => {
  const { t } = useTranslation();

  return (
    <BottomSheet isOpen={isShown} onClose={onClose} title={t('portfolios.returnMethodology.title')}>
      <img
        src={graph}
        alt={t('portfolios.returnMethodology.chartAlt')}
        css={css`
          margin-bottom: ${spacing.regular};
          width: 100%;
          max-width: 350px;
          display: block;
          margin-left: auto;
          margin-right: auto;
        `}
      />
      <p
        css={css`
          margin-bottom: ${spacing.regular};
          ${fontStyles.cat}
        `}
      >
        {t('portfolios.returnMethodology.backtesting')}
      </p>
      <p
        css={css`
          margin-bottom: ${spacing.regular};
          ${fontStyles.cat}
        `}
      >
        {t('portfolios.returnMethodology.allocations')}
      </p>
      <p
        css={css`
          margin-bottom: ${spacing.regular};
          ${fontStyles.cat}
        `}
      >
        {t('portfolios.returnMethodology.pastPerformance')}
      </p>
      <Button
        variant="secondary"
        block
        onClick={onClose}
        css={css`
          margin-top: ${spacing.regular};
          ${fontStyles.cat}
        `}
      >
        {t('portfolios.returnMethodology.close')}
      </Button>
    </BottomSheet>
  );
};

export default ReturnMethodologyBottomSheet;
